/**
 * Sticky banner der tydeligt viser at sælger/admin handler på vegne af en kunde.
 */
import { UserCheck, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useImpersonation } from "@/features/sales/ImpersonationContext";

export function ImpersonationBanner() {
  const { company, isImpersonating, stopImpersonation } = useImpersonation();

  if (!isImpersonating || !company) return null;

  return (
    <div
      role="status"
      className="sticky top-0 z-50 flex min-h-11 items-center justify-between gap-2 bg-amber-500 px-3 py-2 text-sm font-medium text-amber-950"
    >
      <div className="flex min-w-0 items-center gap-2">
        <UserCheck className="h-4 w-4 shrink-0" aria-hidden />
        <span className="truncate">
          Du handler på vegne af <strong>{company.name}</strong>
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        className="min-h-9 shrink-0 text-amber-950 hover:bg-amber-400"
        onClick={() => {
          stopImpersonation();
          toast.success("Kundevisning afsluttet");
        }}
      >
        <X className="mr-1 h-4 w-4" aria-hidden />
        Stop
      </Button>
    </div>
  );
}
